import { NavLink, Link, useNavigate, useParams } from 'react-router-dom'
import { FaShare } from 'react-icons/fa'
import { useState, useEffect } from "react";
import { alert_error, alert_success } from "../../AppContext.js";
import ProfileNav from "./ProfileNav.jsx";
import Orders from './orders.jsx';
import Api_docs from './api_docs.jsx';
import Scam_check from '../../shop/scams_check/main.jsx';

function Home() {
  const { slug_2 } = useParams();
  const [userOption, setUserOption] = useState(slug_2);
  useEffect(() => {
    setUserOption(slug_2);
  }, [slug_2]);
  const navigate = useNavigate();
  return (
    <>
      <div className='text-center'>
        <div className='inline-block  text-center font-medium text-gray-700   mt-1 rounded-xl'>
          <ProfileNav userOption={userOption} setUserOption={setUserOption} />
        </div>
      </div>
      {userOption === "media" && (
        <>
          <Orders />
        </>
      )}
      {userOption === "traffix" && (
        <>
          <Orders />
        </>
      )}
      {userOption === "accounts" && (
        <>
          <Orders />
        </>
      )}
      {userOption === "api_docs" && (
        <>
          <Api_docs category="servers_orders"/>
        </>
      )}
      {userOption === "check" && (
        <>
          <Scam_check />
        </>
      )}
      <br></br> <br></br>
    </>
  )
}
export default Home
